<div class="container content-box">
    <h2>Account Settings</h2>
    <div class="accordion" id="settingsPage">
        <div class="card">
            <div class="card-header" id="headingOne">
                <h2 class="mb-0">
                    <button class="btn btn-default accordion-button" type="button" data-toggle="collapse" data-target="#personal" aria-expanded="true" aria-controls="personal">
                Personal Information
              </button>
                </h2>
            </div>
            <div id="personal" class="collapse show" aria-labelledby="headingPersonal" data-parent="#settingsPage">
                <div class="card-body">
                    <form (ngSubmit)="onPersonalSubmit()">
                        <div class="form-group row">
                            <label for="firstName" class="col-sm-2 col-form-label">First Name</label>
                            <div class="col">
                                <input name="firstName" type="text" [(ngModel)]="user.firstName" class="form-control" />
                            </div>
                        </div>
                        <div class="form-group row">
                            <label for="lastName" class="col-sm-2 col-form-label">Last Name</label>
                            <div class="col">
                                <input name="lastName" type="text" [(ngModel)]="user.lastName" class="form-control" />
                            </div>
                        </div>
                        <div class="form-group row">
                          <label for="email" class="col-sm-2 col-form-label">Email</label>
                          <div class="col">
                              <input name="email" type="email" [(ngModel)]="user.email" class="form-control" />
                          </div>
                      </div>

                        <div class="form-group float-right">
                            <button [disabled]="loading" type="submit" class="btn btn-light">
                            <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
                            <fa-icon *ngIf="ok" [icon]="['fas', 'check']" style="color: #080;"></fa-icon>
                            <fa-icon *ngIf="error" [icon]="['fas', 'times']" style="color: #c00;"></fa-icon>
                              <span>Save</span>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>

        <div class="card">
            <div class="card-header" id="headingOne">
                <h2 class="mb-0">
                    <button class="btn btn-default accordion-button collapsed" type="button" data-toggle="collapse" data-target="#security" aria-expanded="true" aria-controls="security">
              Security
            </button>
                </h2>
            </div>
            <div id="security" class="collapse" aria-labelledby="headingSecurity" data-parent="#settingsPage">
                <div class="card-body">
                    <form (ngSubmit)="onSecuritySubmit()">
                        <div class="form-group row">
                            <label for="password" class="col-sm-2 col-form-label">New Password</label>
                            <div class="col">
                                <input name="password" type="text" [(ngModel)]="user.password" class="form-control" />
                            </div>
                        </div>

                        <div class="form-group float-right">
                            <button [disabled]="loading" type="submit" class="btn btn-light">
                            <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
                            <fa-icon *ngIf="ok" [icon]="['fas', 'check']" style="color: #080;"></fa-icon>
                            <fa-icon *ngIf="error" [icon]="['fas', 'times']" style="color: #c00;"></fa-icon>                            
                            <span>Save</span>
                  </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>

    </div>
</div>